<table class="isf-batch-items">
  <thead>
    <tr class="isf-batch-item-header">
      <th class="isf-batch-item-header-checkbox">
        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            class="custom-control-input"
            id="isf-batch-item-all"
            [disabled]="isAllInvalid"
            [ngModel]="isAllChecked"
            (ngModelChange)="isCheckedAllChange.emit($event)"
          />
          <label class="custom-control-label" for="isf-batch-item-all">
            <span class="invisible">all</span>
          </label>
        </div>
      </th>
      <th class="isf-batch-item-header-ref-number">
        {{ "LABELS.REFERENCE_NUMBERS" | translate }}
      </th>
      <th class="isf-batch-item-header-bl">
        {{ "DOCUMENT_TYPE.BILL_OF_LADING" | translate }}
      </th>
      <th class="isf-batch-item-header-seller">{{ "LABELS.SELLER" | translate }}</th>
      <th class="isf-batch-item-header-actions">
        <div class="isf-batch-item-header-actions-wrapper">
          <span>{{ "TOTAL_CONFIRMED_ISF" | translate }}:</span>
          <span class="isf-batch-item-header-actions-count">{{ checkedItemIds.length }}</span>
        </div>
      </th>
    </tr>
  </thead>

  <tbody>
    <tr
      class="isf-batch-item"
      [ngClass]="{
        'isf-batch-item-is-checked': isChecked(isf.id),
        'isf-batch-item-is-checked-next': isCheckedNext(i),
        'isf-batch-item-is-last': last
      }"
      *ngFor="let isf of isfItems; let last = last; let i = index"
    >
      <td class="isf-batch-item-checkbox">
        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            class="custom-control-input"
            id="isf-batch-item-{{ isf.referenceNumber }}"
            [disabled]="!isf.valid"
            [ngModel]="isChecked(isf.id)"
            (ngModelChange)="isCheckedChange.emit({ id: isf.id, checked: $event })"
          />
          <label class="custom-control-label" for="isf-batch-item-{{ isf.referenceNumber }}">
            <span class="invisible">.</span>
          </label>
        </div>
      </td>
      <td class="isf-batch-item-ref-number">{{ isf.referenceNumber }}</td>
      <td class="isf-batch-item-bl">
        <span *ngIf="!!isf.masterBill">{{ isf.masterBill?.carrier }}{{ isf.masterBill?.number }}</span>
        <span *ngIf="!!isf.houseBill">{{ isf.houseBill?.carrier }}{{ isf.houseBill?.number }}</span>
      </td>
      <td class="isf-batch-item-seller">{{ isf.shipment?.seller?.name }}</td>
      <td class="isf-batch-item-actions">
        <button type="button" class="isf-batch-item-actions-review" (click)="review.emit(isf.id)">
          <div class="isf-batch-item-actions-review-inner">
            <span>{{ "LABELS.REVIEW" | translate }}</span>
            <img class="ml-2" src="assets/icons/icon_arrow_right_green.svg" />
          </div>
        </button>
      </td>
    </tr>
  </tbody>
</table>
